import { mergeClasses } from '@fluentui/react-components';
import {
  TimePicker,
  formatDateToTimeString,
  type TimeSelectionData,
  type TimeSelectionEvents,
} from '@fluentui/react-timepicker-compat';
import { formatTimeOfDay, parseTimeOfDay } from './timeOfDay';

const timeSelectOverrides = `
  .fui-TimeSelect {
    min-width: 0 !important;
    width: 100% !important;
  }
`;

export type TimeSelectProps = {
  value?: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  className?: string;
};

export const TimeSelect = ({
  value,
  onChange,
  disabled,
  className,
}: TimeSelectProps) => {
  const current = value ? parseTimeOfDay(value) : null;

  return (
    <>
      <style>{timeSelectOverrides}</style>
      <TimePicker
        className={mergeClasses('fui-TimeSelect', className)}
        selectedTime={current}
        value={current ? formatDateToTimeString(current) : ''}
        increment={30}
        freeform
        dateAnchor={current ?? undefined}
        disabled={disabled}
        onTimeChange={(
          _event: TimeSelectionEvents,
          data: TimeSelectionData
        ) => {
          if (!data.selectedTime) return;
          onChange(formatTimeOfDay(data.selectedTime));
        }}
      />
    </>
  );
};
